import request from '@/utils/request'

//获取新闻信息
export function getNews(data) {
  return request(
    {
      url: '/api/website/getNewsList',
      method: 'post',
      data,
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return false
      } else {
        return false
      }
    }
  )
}

export function getNewsDetail(data) {
  return request({
    url: '/api/website/getNewsDetails',
    method: 'post',
    data
  })
}
